/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config"; 

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesItemHistoryService = { 
  dataSourceConfig(params) {
    var url = "api/CustomerSaleItemHistory";
    return ApiService.createDataSource(url, params);
  },

};



export { SalesItemHistoryService };
